var map = {
	"./17-cn.webp": 1170,
	"./17.webp": 1171,
	"./27-cn.webp": 1172,
	"./27.webp": 1173,
	"./7-cn.webp": 1174,
	"./7.webp": 1175,
	"./angpao-bg-mobile.jpg": 1176,
	"./angpao-bg.jpg": 1177,
	"./angpao-cn.webp": 1178,
	"./angpao.webp": 1179,
	"./button.png": 1180,
	"./close-eye.png": 1181,
	"./coin-1.png": 1182,
	"./coin.png": 1183,
	"./ketupak-open.png": 1184,
	"./ketupak.png": 1185,
	"./ketupak_ribbon.png": 1186,
	"./rain-1.png": 1187,
	"./rain-2.png": 1188,
	"./rain-3.png": 1189,
	"./raya-bg-mobile.png": 1190,
	"./raya-bg.png": 1191,
	"./shine.png": 1192,
	"./star-1.png": 1193,
	"./star-2.png": 1194
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 462;